import React, { Component } from 'react';
import set from 'lodash/set';
import PropTypes from 'prop-types';
import { isNumericFormatted } from '../../js/app/react/validators';

class AdvInput extends Component {
  constructor() {
    super();
    this.state = {
      value: null,
    };

    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { value, dataType, blankable } = this.props;
    const { ADV } = window;
    let curatedValue = value;

    if (isNumericFormatted(value)) {
      curatedValue = ADV.util.formatValue(value, dataType);
    } else if (!value) {
      curatedValue = '';
    }

    if (blankable && value === '') {
      curatedValue = '';
    }

    this.setState({ value: curatedValue });
  }

  UNSAFE_componentWillReceiveProps({ value, dataType, blankable }) {
    let curatedValue = value;
    if (!isNumericFormatted(value) && !value) {
      curatedValue = '';
    }
    const { ADV } = window;

    if (curatedValue === this.state.value) {
      return;
    }

    if (blankable && value === '') {
      this.setState({ value: '' });

      return;
    }

    const formattedStateValue = ADV.util.formatValue(this.state.value, dataType);
    const formattedCuratedValue = ADV.util.formatValue(curatedValue, dataType);
    if (formattedStateValue !== formattedCuratedValue) {
      this.setState({ value: formattedCuratedValue });
    }
  }

  onBlur(e) {
    const { ADV } = window;
    const { onBlur, nullable, onChange, dataType } = this.props;
    let curatedValue = e.target.value;

    if (nullable && e.target.value === '') {
      curatedValue = null;
      this.setState({
        value: '',
      });
    } else {
      curatedValue = ADV.util.formatValue(e.target.value, dataType);
      this.setState({
        value: curatedValue,
      });
    }

    if (onBlur) {
      onBlur(curatedValue);
    }
    if (onChange) {
      onChange(curatedValue);
    }
  }

  onChange(e) {
    const { onChange } = this.props;
    this.setState({
      value: e.target.value,
    });
    if (onChange) {
      onChange(e.target.value);
    }
  }

  render() {
    return (
      <input
        {...this.props}
        value={this.state.value}
        onChange={this.onChange}
        onBlur={this.onBlur}
      />
    );
  }
}

AdvInput.defaultProps = {
  value: null,
  nullable: false,
  onBlur: null,
  onChange: null,
  blankable: false,
};

AdvInput.propTypes = {
  value: PropTypes.string,
  dataType: PropTypes.string.isRequired,
  nullable: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  blankable: PropTypes.bool,
};

export const advInputTextChanged = (clientId, store, path) => v => {
  store(set({}, path, v), clientId);
};

export default AdvInput;
